import React from 'react';

interface Props{
  width:number,
  height:number,
}

const SvgTemplates = (props:Props) => (
  <svg
    {...props}
    width={52}
    height={52}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.042 13a3.25 3.25 0 0 1 3.25-3.25h9.151a3.25 3.25 0 0 1 2.03.712l3.637 2.91a3.25 3.25 0 0 0 2.03.711h14.568a3.25 3.25 0 0 1 3.25 3.25V39a3.25 3.25 0 0 1-3.25 3.25H10.292A3.25 3.25 0 0 1 7.042 39V13Z"
      fill="#EFB8C8"
    />
    <path
      d="M8.042 13a2.25 2.25 0 0 1 2.25-2.25h9.151c.511 0 1.007.174 1.406.493l3.636 2.909.625-.78-.625.78a4.25 4.25 0 0 0 2.655.931h14.568a2.25 2.25 0 0 1 2.25 2.25V39a2.25 2.25 0 0 1-2.25 2.25H10.292A2.25 2.25 0 0 1 8.042 39V13Z"
      stroke="url(#a)"
      strokeOpacity={0.1}
      strokeWidth={2}
    />
    <g filter="url(#b)">
      <mask id="e" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.8 32.894c1.011 0 1.91-.355 2.695-.946.225-.236.786-.118 1.011.237a.87.87 0 0 1-.112 1.3c-1.01.709-2.246 1.181-3.593 1.181a6.045 6.045 0 0 1-4.38-1.89c-1.122-1.182-1.796-2.837-1.796-4.61 0-1.772.674-3.427 1.797-4.609a6.045 6.045 0 0 1 4.379-1.89c1.684 0 3.256.709 4.266 1.89l3.93 4.137a.963.963 0 0 1 0 1.3.836.836 0 0 1-.561.236.836.836 0 0 1-.561-.236l-3.93-4.137c-.786-.945-1.91-1.418-3.144-1.418-1.123 0-2.246.591-3.144 1.418-.899.828-1.348 2.01-1.348 3.31 0 1.3.562 2.363 1.348 3.309.786.945 1.909 1.418 3.144 1.418Zm10.446-11.227c1.672 0 3.232.709 4.346 1.89 1.114 1.182 1.783 2.837 1.783 4.61 0 1.772-.669 3.427-1.783 4.609a5.977 5.977 0 0 1-4.346 1.89 5.978 5.978 0 0 1-4.345-1.89L23 28.639a.968.968 0 0 1 0-1.3.84.84 0 0 1 1.225 0l3.9 4.137c.78.945 1.895 1.418 3.12 1.418 1.226 0 2.229-.591 3.12-1.418.892-.828 1.338-2.01 1.338-3.31 0-1.3-.446-2.481-1.226-3.427-.78-.945-1.894-1.418-3.12-1.418-1.003 0-1.894.355-2.674.945a.821.821 0 0 1-1.115-.118.875.875 0 0 1 .112-1.3c1.003-.709 2.228-1.181 3.565-1.181Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8 32.894c1.011 0 1.91-.355 2.695-.946.225-.236.786-.118 1.011.237a.87.87 0 0 1-.112 1.3c-1.01.709-2.246 1.181-3.593 1.181a6.045 6.045 0 0 1-4.38-1.89c-1.122-1.182-1.796-2.837-1.796-4.61 0-1.772.674-3.427 1.797-4.609a6.045 6.045 0 0 1 4.379-1.89c1.684 0 3.256.709 4.266 1.89l3.93 4.137a.963.963 0 0 1 0 1.3.836.836 0 0 1-.561.236.836.836 0 0 1-.561-.236l-3.93-4.137c-.786-.945-1.91-1.418-3.144-1.418-1.123 0-2.246.591-3.144 1.418-.899.828-1.348 2.01-1.348 3.31 0 1.3.562 2.363 1.348 3.309.786.945 1.909 1.418 3.144 1.418Zm10.446-11.227c1.672 0 3.232.709 4.346 1.89 1.114 1.182 1.783 2.837 1.783 4.61 0 1.772-.669 3.427-1.783 4.609a5.977 5.977 0 0 1-4.346 1.89 5.978 5.978 0 0 1-4.345-1.89L23 28.639a.968.968 0 0 1 0-1.3.84.84 0 0 1 1.225 0l3.9 4.137c.78.945 1.895 1.418 3.12 1.418 1.226 0 2.229-.591 3.12-1.418.892-.828 1.338-2.01 1.338-3.31 0-1.3-.446-2.481-1.226-3.427-.78-.945-1.894-1.418-3.12-1.418-1.003 0-1.894.355-2.674.945a.821.821 0 0 1-1.115-.118.875.875 0 0 1 .112-1.3c1.003-.709 2.228-1.181 3.565-1.181Z"
        fill="url(#c)"
        shapeRendering="crispEdges"
      />
      <path
        d="m23.495 31.948.601.8.067-.05.057-.06-.725-.69Zm1.011.237-.845.535.053.083.067.07.725-.688Zm-.112 1.3.574.818.023-.016.022-.017-.62-.785Zm-7.972-9.928-.725-.688.725.688Zm8.645 0-.76.65.017.02.018.02.725-.69Zm3.93 4.137.725-.689-.725.689Zm0 1.3-.725-.689.725.689Zm-1.122 0 .724-.689-.724.689Zm-3.93-4.137-.77.64.022.025.023.024.725-.689Zm-6.288 0-.678-.735.678.735Zm0 6.619-.77.639.77-.64Zm17.935-7.919-.727.686.727-.686Zm0 9.219-.727-.686.727.686Zm-8.691 0 .727-.686-.727.686ZM23 28.639l-.728.686.728-.686Zm1.225-1.3-.727.686.727-.686Zm3.9 4.137.772-.637-.021-.025-.023-.024-.728.686Zm6.24 0-.68-.733.68.733Zm.112-6.737.771-.636-.771.636Zm-5.794-.473.577.817.013-.01.013-.01-.603-.796Zm-1.115-.118.728-.686-.728.686Zm.112-1.3-.578-.816-.023.016-.022.018.623.782Zm-4.787 8.301c-.641.482-1.333.745-2.093.745v2c1.26 0 2.365-.447 3.295-1.146l-1.201-1.599Zm2.457.5a1.814 1.814 0 0 0-1.13-.78c-.365-.082-.993-.09-1.45.39l1.45 1.378a.602.602 0 0 1-.318.181.301.301 0 0 1-.122.002c-.01-.002-.064-.012-.12-.1l1.69-1.07Zm-.338 2.62a1.87 1.87 0 0 0 .218-2.773l-1.45 1.378a.13.13 0 0 1-.035-.099.142.142 0 0 1 .016-.056c.009-.018.017-.023.012-.02l1.24 1.57Zm-4.212 1.398c1.585 0 3.017-.557 4.167-1.364l-1.149-1.637c-.87.611-1.91 1-3.018 1v2Zm-5.104-2.203a7.045 7.045 0 0 0 5.104 2.203v-2c-1.401 0-2.714-.59-3.654-1.58l-1.45 1.377Zm-2.072-5.297c0 2.022.768 3.925 2.072 5.297l1.45-1.377c-.943-.992-1.522-2.398-1.522-3.92h-2Zm2.072-5.298c-1.304 1.372-2.072 3.275-2.072 5.297h2c0-1.522.58-2.928 1.521-3.92l-1.45-1.377Zm5.104-2.203a7.045 7.045 0 0 0-5.104 2.203l1.45 1.377a5.045 5.045 0 0 1 3.654-1.58v-2Zm5.026 2.241c-1.212-1.418-3.069-2.24-5.026-2.24v2c1.41 0 2.698.595 3.506 1.54l1.52-1.3Zm3.895 4.098-3.93-4.136-1.45 1.377 3.93 4.137 1.45-1.378Zm0 2.678a1.962 1.962 0 0 0 0-2.678l-1.45 1.378a.097.097 0 0 1-.022-.037v-.004l.002-.006a.095.095 0 0 1 .02-.031l1.45 1.378Zm-1.286.547c.524 0 1.004-.25 1.286-.547l-1.45-1.378a.355.355 0 0 1 .076-.06c.003-.002.03-.015.088-.015v2Zm-1.286-.547c.282.297.761.547 1.286.547v-2c.057 0 .085.013.088.015l.02.011c.008.006.028.02.055.049l-1.45 1.378Zm-3.93-4.137 3.93 4.137 1.45-1.378-3.93-4.136-1.45 1.377ZM20.8 24.44c.97 0 1.8.364 2.376 1.058l1.538-1.279C23.718 23.02 22.3 22.44 20.8 22.44v2Zm-2.466 1.154c.791-.729 1.683-1.154 2.467-1.154v-2c-1.463 0-2.817.757-3.822 1.683l1.355 1.471Zm-1.025 2.573c0-1.07.366-1.966 1.025-2.573l-1.355-1.471c-1.137 1.047-1.67 2.514-1.67 4.044h2Zm1.117 2.67c-.701-.842-1.117-1.687-1.117-2.67h-2c0 1.618.707 2.9 1.579 3.949l1.538-1.279Zm2.375 1.058c-.97 0-1.8-.364-2.375-1.058l-1.538 1.279c.995 1.198 2.413 1.779 3.913 1.779v-2ZM36.32 22.87a6.977 6.977 0 0 0-5.074-2.204v2c1.386 0 2.686.587 3.619 1.576l1.455-1.372Zm2.055 5.296c0-2.021-.761-3.923-2.055-5.296l-1.455 1.372c.934.992 1.51 2.399 1.51 3.924h2Zm-2.055 5.295c1.294-1.373 2.055-3.275 2.055-5.296h-2c0 1.525-.576 2.933-1.51 3.924l1.455 1.372Zm-5.074 2.204c1.958 0 3.778-.83 5.074-2.204l-1.455-1.372a4.978 4.978 0 0 1-3.619 1.576v2Zm-5.073-2.204a6.978 6.978 0 0 0 5.073 2.204v-2a4.978 4.978 0 0 1-3.618-1.576l-1.455 1.372Zm-3.9-4.137 3.9 4.137 1.455-1.372-3.9-4.137-1.455 1.372Zm0-2.672a1.968 1.968 0 0 0 0 2.672l1.455-1.372a.094.094 0 0 1 .02.03l.002.006-.002.006a.094.094 0 0 1-.02.03l-1.455-1.372Zm2.681 0a1.84 1.84 0 0 0-2.68 0l1.454 1.372a.161.161 0 0 1-.23 0l1.456-1.372Zm3.9 4.137-3.9-4.137-1.455 1.372 3.9 4.137 1.455-1.372Zm2.392 1.104c-.958 0-1.777-.362-2.348-1.055l-1.543 1.273c.989 1.198 2.398 1.782 3.891 1.782v-2Zm2.44-1.151c-.798.74-1.568 1.15-2.44 1.15v2c1.58 0 2.816-.77 3.8-1.684l-1.36-1.466Zm1.018-2.576c0 1.072-.365 1.97-1.018 2.576l1.36 1.466c1.13-1.049 1.658-2.515 1.658-4.043h-2Zm-.998-2.791c.635.77.998 1.727.998 2.79h2c0-1.536-.53-2.942-1.455-4.063l-1.543 1.273Zm-2.348-1.055c.958 0 1.777.362 2.348 1.055l1.543-1.273c-.989-1.199-2.398-1.782-3.891-1.782v2Zm-2.07.743c.635-.482 1.32-.743 2.07-.743v-2c-1.255 0-2.354.448-3.278 1.148l1.207 1.595Zm-2.446-.23c.705.748 1.713.748 2.419.249l-1.155-1.633a.156.156 0 0 1 .096-.018c.03.002.056.01.076.02.02.01.026.017.019.01l-1.455 1.372Zm.216-2.768a1.875 1.875 0 0 0-.216 2.768l1.455-1.372a.127.127 0 0 1 .034.095.138.138 0 0 1-.015.055c-.009.017-.017.022-.013.019l-1.245-1.565Zm4.188-1.4c-1.577 0-3 .558-4.143 1.366l1.155 1.633c.863-.61 1.891-.998 2.988-.998v-2Z"
        fill="url(#d)"
        fillOpacity={0.1}
        mask="url(#e)"
      />
    </g>
    <defs>
      <linearGradient
        id="a"
        x1={26}
        y1={9.75}
        x2={26}
        y2={42.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="c"
        x1={26}
        y1={21.666}
        x2={26}
        y2={34.666}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.9} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="d"
        x1={26}
        y1={21.666}
        x2={26}
        y2={34.666}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <filter
        id="b"
        x={14.625}
        y={21.666}
        width={22.75}
        height={14}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1945_2216"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1945_2216"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" />
        <feBlend in2="shape" result="effect2_innerShadow_1945_2216" />
      </filter>
    </defs>
  </svg>
);

export default SvgTemplates;
